import React, {useState, useEffect} from "react";
import EditablePdf from "../../../../components/forms/EditablePdf";
import {Grid, Col} from "../../../../styles/Grid";
import styled from "styled-components";
import {Input, Label} from "../../../../components/forms/DynamicInput";
import EditableImg from "../../../../components/forms/EditableImg";
import {AppButton, ResetButton, ButtonWithIcon} from "../../../../styles/Butttons";
import nextId from "react-id-generator";
import {CreateResourceCourse} from "../../../../services/GeneralServices";
import {ReactComponent as PlusIcon} from "../../../../assets/icons/plus.svg";
import AppLoader from "../../../../components/loaders/Loader";

const MediaCreator = ({idCourse, savePdf}) => {
   const [isSaving, setSavin] = useState(false);
   const [currentMedia, setmedia] = useState([{id: "id0", data: "", name: ""}]);
   const addMedia = () => {
      setmedia([...currentMedia, {id: nextId(), data: "", name: ""}]);
   };

   const setMedia = (id, file) => {
      let newMediaList = currentMedia.map((item) => {
         if (item.id === id) {
            return {...item, data: file.target};
         }
         return item;
      });
      setmedia(newMediaList);
   };
   const setName = (id, val) => {
      let newMediaList = currentMedia.map((item) => {
         if (item.id === id) {
            return {...item, name: val};
         }
         return item;
      });
      setmedia(newMediaList);
   };
   const sendMedia = () => {
      for (let med in currentMedia) {
         let isLast = Number(med) + 1 === currentMedia.length;
         let item = currentMedia[med];
         if (item.data.files) {
            // console.log(item.data.files[0]);
            if (!item.name) {
               SaveResource({...item, name: `Video ${Number(med) + 1}`}, isLast);
            } else {
               SaveResource(item, isLast);
            }
         }
      }
   };

   const SaveResource = (dat, isLast) => {
      setSavin(true);
      let newData = new FormData();
      newData.append("idCourse", idCourse);
      newData.append("resourceName", dat.name);
      newData.append("token", localStorage.getItem("domecq_token"));
      newData.append("pathResource", dat.data.files[0]);

      CreateResourceCourse(newData)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(resp);
            setSavin(false);
            if (isLast) {
               console.log("se guardo el ultomo")
               savePdf();
            }
         })
         .catch((e) => {
            setSavin(false);
            if (isLast) {
               console.log("NO se guardo el ultomo")
               savePdf();
            }
            console.log(e);
         });
   };

   return (
      <>
         <AllGrid>
            <Col large={12} className="sepTop">
               <Label>Videos del curso</Label>

               <Grid>
                  {React.Children.toArray(
                     currentMedia.map((item, index) => {
                        return <MediaItem item={item} index={index} setMedia={setMedia} setName={setName} />;
                     }),
                  )}
               </Grid>

               <Col large={2} className="sepTop">
                  <ButtonWithIcon Icon={PlusIcon} action={addMedia} text="Agregar vídeo" classname="min" />
                  {/* <ResetButton onClick={addMedia}>Agregar vídeo</ResetButton> */}
               </Col>

               <Grid className="sepTop">
                  <Col large={2} offsetL={10}>
                     <AppButton onClick={sendMedia}>Continuar</AppButton>
                  </Col>
               </Grid>
            </Col>
         </AllGrid>
         <AppLoader isVisible={isSaving} />
      </>
   );
};

export default MediaCreator;

const MediaItem = ({item, index, setMedia, setName}) => {
   return (
      <MediaCol large={6} className={`${item.error ? "error" : ""} sepTop`}>
         <Input
            value={item.name}
            placeholder="Nombre del archivo"
            onChange={(e) => {
               setName(item.id, e.target.value);
            }}
         />
         <EditableImg editable={true} change={(e) => setMedia(item.id, e)} label="" name={"media" + index} type="video" />
      </MediaCol>
   );
};

const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const MediaCol = styled(Col)`
   display: flex;
   align-items: flex-end;

   & ${ResetButton} {
      width: auto;
      padding: 0.3em 0.5em;
      height: fit-content;
      color: crimson;
   }

   &.error {
      background: red;
   }

   .row {
      width: 90%;
   }

   &.sepTop {
      margin-top: 1em;
   }
`;

const Title = styled.p``;

const ClasesText = styled.textarea`
   font-size: 1em;
   font-family: Montserrat;
   resize: none;
   width: 100%;
   height: 120px;
   margin: 0.5em 0;
`;
